export function formatMoney(cents: number) {
  return `$${(cents / 100).toFixed(2)}`;
}

export function lineSubtotal(item: {
  quantity: number;
  unit_amount_cents: number;
}) {
  return Math.round(item.quantity * item.unit_amount_cents);
}

export function lineGst(item: {
  quantity: number;
  unit_amount_cents: number;
  gst_rate: number;
}) {
  return Math.round(lineSubtotal(item) * (item.gst_rate / 100));
}

export function todayPlus(days: number) {
  const date = new Date();
  date.setDate(date.getDate() + days);
  return date.toISOString().slice(0, 10);
}

export function formatDuration(seconds: number) {
  const hours = seconds / 3600;
  return `${hours.toFixed(hours >= 10 ? 0 : 1)}h`;
}

export function timeEntryValue(entry: {
  duration_seconds: number;
  hourly_rate_cents: number | null;
}) {
  if (!entry.hourly_rate_cents) return 0;
  return Math.round((entry.duration_seconds / 3600) * entry.hourly_rate_cents);
}

export const INVOICE_STATUS_ACTIONS = [
  { label: "Draft", value: "draft" },
  { label: "Mark sent", value: "sent" },
  { label: "Mark paid", value: "paid" },
  { label: "Overdue", value: "overdue" },
  { label: "Void", value: "void" },
] as const;

export const CADENCE_OPTIONS = [
  { label: "Weekly", value: "weekly" },
  { label: "Fortnightly", value: "fortnightly" },
  { label: "Monthly", value: "monthly" },
  { label: "Quarterly", value: "quarterly" },
];

export type RecurringLineItemForm = {
  description: string;
  gstRate: string;
  quantity: string;
  unitAmount: string;
};

export function createRecurringLineItem(
  input?: Partial<RecurringLineItemForm>,
): RecurringLineItemForm {
  return {
    description: input?.description ?? "",
    gstRate: input?.gstRate ?? "0",
    quantity: input?.quantity ?? "1",
    unitAmount: input?.unitAmount ?? "",
  };
}

export function recurringTemplateLineItems(template: unknown) {
  if (
    !template ||
    typeof template !== "object" ||
    !("line_items" in template)
  ) {
    return [] as RecurringLineItemForm[];
  }
  const items = (template as { line_items?: unknown }).line_items;
  if (!Array.isArray(items)) return [];
  return items
    .map((item) => {
      if (!item || typeof item !== "object") return null;
      const record = item as {
        description?: string;
        gst_rate?: number;
        quantity?: number;
        unit_amount_cents?: number;
      };
      return createRecurringLineItem({
        description: record.description ?? "",
        gstRate: String(record.gst_rate ?? 0),
        quantity: String(record.quantity ?? 1),
        unitAmount: record.unit_amount_cents
          ? String(record.unit_amount_cents / 100)
          : "",
      });
    })
    .filter((item): item is RecurringLineItemForm => Boolean(item));
}

export function serializeRecurringLineItems(items: RecurringLineItemForm[]) {
  return JSON.stringify(items);
}

export function hasRecurringLineItem(items: RecurringLineItemForm[]) {
  return items.some((item) => item.description.trim());
}

export function dateOnly(value: string) {
  return value.slice(0, 10);
}
